<div class="paymentCompletedWhole">
        <img src="../../assets/img/closeChat.png" (click)="closed()" class="closingPngPaymCompleted"  alt="closeIcon">
        <div class="paymentCompletedDivs">
            <img class="checkedPaymCompleted" src="../../assets/img/checked.png" alt="checkIcon">
            <div class="paymentCompleted">Payment Completed!</div>
            <button class="okBtn" (click)="closed()">Ok</button>
        </div>
    </div>

